import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import axios from "axios";

Vue.use(VueRouter);

// Layout
import UnAuthLayout from "../views/layouts/unauth-layout.vue";
import AuthLayout from "../views/layouts/auth-layout.vue";

// Static
import HomePage from "../views/home";

// Auth
import LoginPage from "../views/auth/login.vue";
import ForgotPasswordPage from "../views/auth/forgot-password.vue";

// Companies
import CompaniesPage from "../views/companies/index.vue";
import CompanyCreatePage from "../views/companies/create.vue";
import CompanyIdPage from "../views/companies/id.vue";

// Users
import UsersPage from "../views/users/index.vue";
import UserCreatePage from "../views/users/create.vue";
import UserIdPage from "../views/users/id.vue";
import ProfilePage from "../views/users/id.vue";
import DeviceResetRequestPage from "../views/users/device-reset-requests.vue";
import LocationResetRequestPage from "../views/users/location-reset-requests.vue";
import UsersUploadPage from "../views/users/upload.vue";
import ImeiNumbersPage from "../views/users/imei-numbers.vue";

// Bank Details
import BankDetailsPage from "../views/bank_details/index.vue";
import BankDetailCreatePage from "../views/bank_details/create.vue";
import BankDetailIdPage from "../views/bank_details/id.vue";

// Withdrawal Logs
import WithdrawalLogsPage from "../views/withdrawal_logs/index.vue";
import WithdrawalLogCreatePage from "../views/withdrawal_logs/create.vue";
import WithdrawalLogIdPage from "../views/withdrawal_logs/id.vue";

// KYC Approved Users
import KycApprovedUsersPage from "../views/kyc-approved/index.vue";

// Positions
import PositionsPage from "../views/positions/index.vue";
import PositionCreatePage from "../views/positions/create.vue";
import PositionIdPage from "../views/positions/id.vue";

// Roles
import RolesPage from "../views/roles/index.vue";
import RoleIdPage from "../views/roles/id.vue";

// Modules
import ModulesPage from "../views/modules/index.vue";
import ModuleCreatePage from "../views/modules/create.vue";
import ModuleIdPage from "../views/modules/id.vue";
// Sample Execel
import SamplesPage from "../views/sample-excels/index.vue";
import SampleCreatePage from "../views/sample-excels/create.vue";
import SampleIdPage from "../views/sample-excels/id.vue";

// Permissions
import PermissionsPage from "../views/permissions/index.vue";
import PermissionCreatePage from "../views/permissions/create.vue";
import PermissionIdPage from "../views/permissions/id.vue";

// Values
import Values from "@/views/values/index.vue";
import ValueCreate from "@/views/values/create.vue";
import ValueId from "@/views/values/id.vue";

// ValueLists
import ValueLists from "@/views/value-lists/index.vue";
import ValueListUpload from "@/views/value-lists/upload.vue";
import ValueListCreate from "@/views/value-lists/create.vue";
import ValueListId from "@/views/value-lists/id.vue";

// User Timestamps
import UserTimestamps from "@/views/user-timestamps/index.vue";
import SaleReports from "@/views/sale-reports/index.vue";

// import ModulesPage from "../views/modules/index.vue";
// import ModuleCreatePage from "../views/modules/create.vue";
// import ModuleIdPage from "../views/modules/id.vue";

// RawMaterials
import RawMaterialsPage from "../views/raw-materials/index.vue";
import RawMaterialCreatePage from "../views/raw-materials/create.vue";
import RawMaterialIdPage from "../views/raw-materials/id.vue";
// RawMaterialConsumptions
import MaterialConversionsPage from "../views/material-conversions/index.vue";
import MaterialConversionCreatePage from "../views/material-conversions/create.vue";
import MaterialConversionIdPage from "../views/material-conversions/id.vue";

import MaterialConversionLogsPage from "../views/material-conversion-logs/index.vue";
import MaterialConversionLogCreatePage from "../views/material-conversion-logs/create.vue";
import MaterialConversionLogIdPage from "../views/material-conversion-logs/id.vue";
// RawMaterialConsumptionLogs
import RawMaterialPurchasesPage from "../views/raw-material-purchases/index.vue";
import RawMaterialPurchaseCreatePage from "../views/raw-material-purchases/create.vue";
import RawMaterialPurchaseIdPage from "../views/raw-material-purchases/id.vue";
// Products
import ProductsPage from "../views/products/index.vue";
import ProductCreatePage from "../views/products/create.vue";
import ProductIdPage from "../views/products/id.vue";
// GiftCategories
import GiftCategoriesPage from "../views/gift-categories/index.vue";
import GiftCategoryCreatePage from "../views/gift-categories/create.vue";
import GiftCategoryIdPage from "../views/gift-categories/id.vue";
// Gifts
import GiftsPage from "../views/gifts/index.vue";
import GiftCreatePage from "../views/gifts/create.vue";
import GiftIdPage from "../views/gifts/id.vue";
// GiftPurchaseOrders
import GiftPurchaseOrdersPage from "../views/gift-purchase-orders/index.vue";
import GiftPurchaseOrderCreatePage from "../views/gift-purchase-orders/create.vue";
import GiftPurchaseOrderIdPage from "../views/gift-purchase-orders/id.vue";
// GiftRedemptions
import GiftRedemptionsPage from "../views/gift-redemptions/index.vue";
import GiftRedemptionCreatePage from "../views/gift-redemptions/create.vue";
import GiftRedemptionIdPage from "../views/gift-redemptions/id.vue";
// Productions
import ProductionsPage from "../views/productions/index.vue";
import ProductionCreatePage from "../views/productions/create.vue";
import ProductionIdPage from "../views/productions/id.vue";
// Stores
import StoresPage from "../views/stores/index.vue";
import StoreCreatePage from "../views/stores/create.vue";
import StoreIdPage from "../views/stores/id.vue";
// Sales
import SalesPage from "../views/sales/index.vue";
import SaleCreatePage from "../views/sales/create.vue";
import SaleIdPage from "../views/sales/id.vue";
// PointMappings
import PointMappingsPage from "../views/point-mappings/index.vue";
import PointMappingCreatePage from "../views/point-mappings/create.vue";
import PointMappingIdPage from "../views/point-mappings/id.vue";
// PointMappinglogs
import PointMappingLogsPage from "../views/point-mapping-logs/index.vue";
import PointMappingLogCreatePage from "../views/point-mapping-logs/create.vue";
import PointMappingLogIdPage from "../views/point-mapping-logs/id.vue";

// // InquiryRequests
import InquiryRequestsPage from "../views/inquiry-requests/index.vue";
import InquiryRequestCreatePage from "../views/inquiry-requests/create.vue";
import InquiryRequestIdPage from "../views/inquiry-requests/id.vue";
// // ContactRequests
import ContactRequestsPage from "../views/contact-requests/index.vue";
import ContactRequestCreatePage from "../views/contact-requests/create.vue";
import ContactRequestIdPage from "../views/contact-requests/id.vue";
// // UserWalletLogs
import UserWalletsPage from "../views/user-wallet-logs/index.vue";
import UserWalletCreatePage from "../views/user-wallet-logs/create.vue";
import UserWalletIdPage from "../views/user-wallet-logs/id.vue";
// // Sale_details
import SaleDetailsPage from "../views/sale-details/index.vue";
// import SaleDetailCreatePage from "../views/sale-details/create.vue";
// import SaleDetailIdPage from "../views/sale-details/id.vue";

// Store_Gift
import StoreGiftsPage from "../views/store-gifts/index.vue";
import StoreGiftCreatePage from "../views/store-gifts/create.vue";
import StoreGiftIdPage from "../views/store-gifts/id.vue";
import StoreGiftsUploadPage from "../views/store-gifts/upload.vue";

// StoreProduct
import StoreProductsPage from "../views/store-products/index.vue";
import StoreProductCreatePage from "../views/store-products/create.vue";
import StoreProductIdPage from "../views/store-products/id.vue";
import StoreProductsUploadPage from "../views/store-products/upload.vue";

// StoreProductStocks
import StoreProductStocksPage from "../views/product-stocks/index.vue";
import StoreProductStockCreatePage from "../views/product-stocks/create.vue";
//  import StoreProductStockIdPage from "../views/product-stocks/id.vue";
// StoreGiftStocks
import StoreGiftStocksPage from "../views/gift-stocks/index.vue";
import StoreGiftStockCreatePage from "../views/gift-stocks/create.vue";
//  import StoreGiftStockIdPage from "../views/gift-stocks/id.vue";
// Cancellations Logs
import DeleteAccountRequestPage from "../views/delete-requests/create.vue";
import DeleteAccountRequestIndexPage from "../views/delete-requests/index.vue";

// StoreProduct
import NotificationsPage from "../views/notifications/index.vue";
import NotificationCreatePage from "../views/notifications/create.vue";
import NotificationIdPage from "../views/notifications/id.vue";

// Orders
import OrdersPage from "../views/orders/index.vue";
import OrderCreatePage from "../views/orders/create.vue";
import OrderIdPage from "../views/orders/id.vue";
// Order Details
import OrderDetailsPage from "../views/order-details/index.vue";

// FestivalBanners
import FestivalBannersPage from "../views/festival-banners/index.vue";
import FestivalBannerCreatePage from "../views/festival-banners/create.vue";
import FestivalBannerIdPage from "../views/festival-banners/id.vue";
//CancellationLogs
import CancellationLogsPage from "../views/cancellation-logs/index.vue";
// TrackProgresses
import TrackProgressesPage from "../views/track-progress/index.vue";
import TrackProgressCreatePage from "../views/track-progress/create.vue";
import TrackProgressIdPage from "../views/track-progress/id.vue";
// Booster Driver Rewards
import BoosterDriverRewardsPage from "../views/booster-driver-rewards/index.vue";
import BoosterDriverRewardCreatePage from "../views/booster-driver-rewards/create.vue";
import BoosterDriverRewardIdPage from "../views/booster-driver-rewards/id.vue";
// Booster Driver Logs
import BoosterDriverLogsPage from "../views/booster-driver-logs/index.vue";
// Reward Logs
import RewardLogsPage from "../views/reward-logs/index.vue";
// WelcomeBonus
import WelcomeBonusesPage from "../views/welcome-bonus/index.vue";
import WelcomeBonusCreatePage from "../views/welcome-bonus/create.vue";
import WelcomeBonusIdPage from "../views/welcome-bonus/id.vue";
// Track Success Enquiry Point
import TrackSuccessPointsPage from "../views/track-success-points/index.vue";
import TrackSuccessPointCreatePage from "../views/track-success-points/create.vue";
import TrackSuccessPointIdPage from "../views/track-success-points/id.vue";
// Track Success Enquiry Point
import TopTenSuccesPointsPage from "../views/top-ten-field-hero-points/index.vue";
import TopTenSuccesPointCreatePage from "../views/top-ten-field-hero-points/create.vue";
import TopTenSuccesPointIdPage from "../views/top-ten-field-hero-points/id.vue";
// Marketing Supervisor Logs
import MarketingSupervisorLogsPage from "../views/marketing-supervisor-logs/index.vue";
// Enquiry Rewards
import EnquiryRewardsPage from "../views/enquiry-form-rewards/index.vue";
import EnquiryRewardsPage2 from "../views/enquiry-form-rewards/update.vue";
import EnquiryRewardCreatePage from "../views/enquiry-form-rewards/create.vue";
import EnquiryRewardIdPage from "../views/enquiry-form-rewards/id.vue";
// Enquiry Rewards
import GiftCatalogsPage from "../views/gift-catalogs/index.vue";
import GiftCatalogIdPage2 from "../views/gift-catalogs/index2.vue";
import GiftCatalogCreatePage from "../views/gift-catalogs/create.vue";
import GiftCatalogIdPage from "../views/gift-catalogs/id.vue";
// GiftOrders
import GiftOrdersPage2 from "../views/gift-orders/update.vue";
import GiftOrdersPage from "../views/gift-orders/index.vue";
import GiftOrderCreatePage from "../views/gift-orders/create.vue";
import GiftOrderIdPage from "../views/gift-orders/id.vue";
import GiftOrderHistoryPage from "../views/gift-order-history/index.vue";

// Old User Data
import OldUserDatasPage from "../views/old-user-datas/index.vue";
import OldUserDataCreatePage from "../views/old-user-datas/create.vue";
import OldUserDataIdPage from "../views/old-user-datas/id.vue";
import OldUserDatasUploadPage from "../views/old-user-datas/upload.vue";

// Old User Used Point
import OldUserUsedPointsPage from "../views/old-user-used-points/index.vue";
import OldUserUsedPointCreatePage from "../views/old-user-used-points/create.vue";
import OldUserUsedPointIdPage from "../views/old-user-used-points/id.vue";
import OldUserUsedPointsUploadPage from "../views/old-user-used-points/upload.vue";

// Chats
import ChatPage from "../views/chats/index.vue";

// Messenger (Real-time chat)
import MessengerPage from "../views/messenger/index.vue";

// RaiseComplaints
import RaiseComplaintsPage from "../views/raise-complaints/index.vue";
import RaiseComplaintCreatePage from "../views/raise-complaints/create.vue";
import RaiseComplaintIdPage from "../views/raise-complaints/id.vue";

// PayCreditBalance
import PayCreditBalancePage from "../views/pay-credit-balance/index.vue";
import PayCreditBalanceCreatePage from "../views/pay-credit-balance/create.vue";
import PayCreditBalanceIdPage from "../views/pay-credit-balance/id.vue";

// Vendors
import VendorsPage from "../views/vendors/index.vue";
import VendorCreatePage from "../views/vendors/create.vue";
import VendorIdPage from "../views/vendors/id.vue";

// Shipments
import CreateShipmentPage from "../views/shipments/create.vue";

// API Monitoring
import ApiLogsPage from "../views/api-logs/index.vue";
import ApiLogIdPage from "../views/api-logs/id.vue";
import ErrorLogsPage from "../views/error-logs/index.vue";
import ErrorLogIdPage from "../views/error-logs/id.vue";

const routes = [
  // AuthLayout
  {
    path: "/auth",
    name: "AuthLayout",
    component: AuthLayout,
    children: [
      {
        path: "/home",
        name: "HomePage",
        component: HomePage,
      },
      // Comapnies
      {
        path: "/companies",
        name: "CompaniesPage",
        component: CompaniesPage,
      },
      {
        path: "/companies/create",
        name: "CompanyCreatePage",
        component: CompanyCreatePage,
      },
      {
        path: "/companies/:companyId",
        name: "CompanyIdPage",
        component: CompanyIdPage,
      },
      // Users
      {
        path: "/users",
        name: "UsersPage",
        component: UsersPage,
      },
      {
        path: "/users/create",
        name: "UserCreatePage",
        component: UserCreatePage,
      },
      {
        path: "/users/upload",
        name: "UsersUploadPage",
        component: UsersUploadPage,
      },
      {
        path: "/users/imei-numbers",
        name: "ImeiNumbersPage",
        component: ImeiNumbersPage,
      },
      // KYC Approved Users
      {
        path: "/kyc-approved-users",
        name: "KycApprovedUsersPage",
        component: KycApprovedUsersPage,
      },
      {
        path: "/profile/:userId",
        name: "ProfilePage",
        component: ProfilePage,
      },
      {
        path: "/users/:userId",
        name: "UserIdPage",
        component: UserIdPage,
      },
      {
        path: "/device-reset-requests",
        name: "DeviceResetRequestPage",
        component: DeviceResetRequestPage,
      },
      {
        path: "/location-reset-requests",
        name: "LocationResetRequestPage",
        component: LocationResetRequestPage,
      },
      // Vendors
      {
        path: "/vendors",
        name: "VendorsPage",
        component: VendorsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/vendors/create",
        name: "VendorCreatePage",
        component: VendorCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/vendors/:id",
        name: "VendorIdPage",
        component: VendorIdPage,
        meta: { requiresAuth: true }
      },
      // Bank Details
      {
        path: "/bank_details",
        name: "BankDetailsPage",
        component: BankDetailsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/bank_details/create",
        name: "BankDetailCreatePage",
        component: BankDetailCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/bank_details/:id",
        name: "BankDetailIdPage",
        component: BankDetailIdPage,
        meta: { requiresAuth: true }
      },
      // Withdrawal Logs
      {
        path: "/withdrawal_logs",
        name: "WithdrawalLogsPage",
        component: WithdrawalLogsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/withdrawal_logs/create",
        name: "WithdrawalLogCreatePage",
        component: WithdrawalLogCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/withdrawal_logs/:id",
        name: "WithdrawalLogIdPage",
        component: WithdrawalLogIdPage,
        meta: { requiresAuth: true }
      },
      // Positions
      {
        path: "/positions",
        name: "PositionsPage",
        component: PositionsPage,
      },
      {
        path: "/positions/create",
        name: "PositionCreatePage",
        component: PositionCreatePage,
      },
      {
        path: "/positions/:positionId",
        name: "PositionIdPage",
        component: PositionIdPage,
      },
      // Roles
      {
        path: "/roles",
        name: "RolesPage",
        component: RolesPage,
      },
      {
        path: "/roles/:roleId",
        name: "RoleIdPage",
        component: RoleIdPage,
      },
      // Modules
      {
        path: "/modules",
        name: "ModulesPage",
        component: ModulesPage,
      },
      {
        path: "/modules/create",
        name: "ModuleCreatePage",
        component: ModuleCreatePage,
      },
      {
        path: "/modules/:moduleId",
        name: "ModuleIdPage",
        component: ModuleIdPage,
      },
      // Modules
      {
        path: "/samples",
        name: "SamplesPage",
        component: SamplesPage,
      },
      {
        path: "/samples/create",
        name: "SampleCreatePage",
        component: SampleCreatePage,
      },
      {
        path: "/samples/:sampleId",
        name: "SampleIdPage",
        component: SampleIdPage,
      },
      // Rawmaterials
      {
        path: "/raw-materials",
        name: "RawMaterialsPage",
        component: RawMaterialsPage,
      },
      {
        path: "/raw-materials/create",
        name: "RawMaterialCreatePage",
        component: RawMaterialCreatePage,
      },
      {
        path: "/raw-materials/:rawMaterialId",
        name: "RawMaterialIdPage",
        component: RawMaterialIdPage,
      },
      // Rawmaterialconsumptions
      {
        path: "/material-conversions",
        name: "MaterialConversionsPage",
        component: MaterialConversionsPage,
      },
      {
        path: "/material-conversions/create",
        name: "MaterialConversionCreatePage",
        component: MaterialConversionCreatePage,
      },
      {
        path: "/material-conversions/:materialConversionId", //camel
        name: "MaterialConversionIdPage",
        component: MaterialConversionIdPage,
      },
      // Rawmaterialconsumptionlogs
      {
        path: "/material-conversion-logs",
        name: "MaterialConversionLogsPage",
        component: MaterialConversionLogsPage,
      },
      {
        path: "/material-conversion-logs/create",
        name: "MaterialConversionLogCreatePage",
        component: MaterialConversionLogCreatePage,
      },
      {
        path: "/material-conversion-logs/:materialConversionLogId", //camel
        name: "MaterialConversionLogIdPage",
        component: MaterialConversionLogIdPage,
      },
      // RawMaterialPurchases
      {
        path: "/raw-material-purchases",
        name: "RawMaterialPurchasesPage",
        component: RawMaterialPurchasesPage,
      },
      {
        path: "/raw-material-purchases/create",
        name: "RawMaterialPurchaseCreatePage",
        component: RawMaterialPurchaseCreatePage,
      },
      {
        path: "/raw-material-purchases/:rawMaterialPurchaseId", //camel
        name: "RawMaterialPurchaseIdPage",
        component: RawMaterialPurchaseIdPage,
      },
      // Products
      {
        path: "/products",
        name: "ProductsPage",
        component: ProductsPage,
      },
      {
        path: "/products/create",
        name: "ProductCreatePage",
        component: ProductCreatePage,
      },
      {
        path: "/products/:productId",
        name: "ProductIdPage",
        component: ProductIdPage,
      },
      // Products
      {
        path: "/point-mapping-logs",
        name: "PointMappingLogsPage",
        component: PointMappingLogsPage,
      },
      {
        path: "/point-mapping-logs/create",
        name: "PointMappingLogCreatePage",
        component: PointMappingLogCreatePage,
      },
      {
        path: "/point-mapping-logs/:pointMappingLogId",
        name: "PointMappingLogIdPage",
        component: PointMappingLogIdPage,
      },
      // GiftCategories
      {
        path: "/gift-categories",
        name: "GiftCategoriesPage",
        component: GiftCategoriesPage,
      },
      {
        path: "/gift-categories/create",
        name: "GiftCategoryCreatePage",
        component: GiftCategoryCreatePage,
      },
      {
        path: "/gift-categories/:giftCategoryId",
        name: "GiftCategoryIdPage",
        component: GiftCategoryIdPage,
      },
      // Gift
      {
        path: "/gifts",
        name: "GiftsPage",
        component: GiftsPage,
      },
      {
        path: "/gifts/create",
        name: "GiftCreatePage",
        component: GiftCreatePage,
      },
      {
        path: "/gifts/:giftId",
        name: "GiftIdPage",
        component: GiftIdPage,
      },
      // GiftPurchaseOrder
      {
        path: "/gift-purchase-orders",
        name: "GiftPurchaseOrdersPage",
        component: GiftPurchaseOrdersPage,
      },
      {
        path: "/gift-purchase-orders/create",
        name: "GiftPurchaseOrderCreatePage",
        component: GiftPurchaseOrderCreatePage,
      },
      {
        path: "/gift-purchase-orders/:giftPurchaseOrderId", //camel case
        name: "GiftPurchaseOrderIdPage",
        component: GiftPurchaseOrderIdPage,
      },
      // GiftRedemption
      {
        path: "/gift-redemptions",
        name: "GiftRedemptionsPage",
        component: GiftRedemptionsPage,
      },
      {
        path: "/gift-redemptions/create",
        name: "GiftRedemptionCreatePage",
        component: GiftRedemptionCreatePage,
      },
      {
        path: "/gift-redemptions/:giftredemptionId", //camel case
        name: "GiftRedemptionIdPage",
        component: GiftRedemptionIdPage,
      },
      // Production
      {
        path: "/productions",
        name: "ProductionsPage",
        component: ProductionsPage,
      },
      {
        path: "/productions/create",
        name: "ProductionCreatePage",
        component: ProductionCreatePage,
      },
      {
        path: "/productions/:productionId",
        name: "ProductionIdPage",
        component: ProductionIdPage,
      },
      // UserWallet
      {
        path: "/user-wallet-logs",
        name: "UserWalletsPage",
        component: UserWalletsPage,
      },
      {
        path: "/user-wallet-logs/create",
        name: "UserWalletCreatePage",
        component: UserWalletCreatePage,
      },
      {
        path: "/user-wallet-logs/:userWalletLogId",
        name: "UserWalletIdPage",
        component: UserWalletIdPage,
      },
      // SaleDetails
      {
        path: "/sales/:saleId/sale-details",
        name: "SaleDetailsPage",
        component: SaleDetailsPage,
      },
      // {
      //   path: "sale-details/create",
      //   name: "SaleDetailCreatePage",
      //   component: SaleDetailCreatePage,
      // },
      // {
      //   path: "sale-details/:userWalletLogId",
      //   name: "SaleDetailIdPage",
      //   component: SaleDetailIdPage,
      // },
      // StoreGift
      // {
      //   path: "/store-gifts",
      //   name: "StoreGiftsPage",
      //   component: StoreGiftsPage,
      // },
      {
        path: "/store-gifts/:storeGiftId",
        name: "StoreGiftIdPage",
        component: StoreGiftIdPage,
      },
      //StoreProduct
      {
        path: "/store-products/:storeProductId",
        name: "StoreProductIdPage",
        component: StoreProductIdPage,
      },
      // StoreProductStock
      // {
      //   path: "/product-stocks/:productId/:storeId",
      //   name: "StoreProductStocksPage",
      //   component: StoreProductStocksPage,
      // },
      // {
      //   path: "/product-stocks/create",
      //   name: "StoreProductStockCreatePage",
      //   component: StoreProductStockCreatePage,
      // },
      // {
      //   path: "/product-stocks/:storeId",
      //   name: "StoreProductStockIdPage",
      //   component: StoreProductStockIdPage,
      // },
      // Store
      {
        path: "/stores",
        name: "StoresPage",
        component: StoresPage,
      },
      {
        path: "/stores/create",
        name: "StoreCreatePage",
        component: StoreCreatePage,
      },
      //store Gifts
      {
        path: "/stores/:storeId/store-gifts",
        name: "StoreGiftsPage",
        component: StoreGiftsPage,
      },
      {
        path: "/stores/:storeId/store-gifts/create",
        name: "StoreGiftCreatePage",
        component: StoreGiftCreatePage,
      },
      {
        path: "/stores/:storeId/store-gifts/upload",
        name: "StoreGiftsUploadPage",
        component: StoreGiftsUploadPage,
      },
      //store Product
      {
        path: "/stores/:storeId/store-products",
        name: "StoreProductsPage",
        component: StoreProductsPage,
      },
      {
        path: "/stores/:storeId/store-products/create",
        name: "StoreProductCreatePage",
        component: StoreProductCreatePage,
      },
      {
        path: "/stores/:storeId/store-products/upload",
        name: "StoreProductsUploadPage",
        component: StoreProductsUploadPage,
      },
      //Store Stock Product
      {
        path: "/store-products/:storeProductId/product-stocks",
        name: "StoreProductStocksPage",
        component: StoreProductStocksPage,
      },
      {
        path: "/store-products/:storeProductId/product-stocks/create",
        name: "StoreProductStockCreatePage",
        component: StoreProductStockCreatePage,
      },
      //Store Stock Product
      {
        path: "/store-gifts/:storeGiftId/gift-stocks",
        name: "StoreGiftStocksPage",
        component: StoreGiftStocksPage,
      },
      {
        path: "/store-gifts/:storeGiftId/gift-stocks/create",
        name: "StoreGiftStockCreatePage",
        component: StoreGiftStockCreatePage,
      },
      // //Store Stock Product
      // {
      //   path: "/store-products/:storeId/:productId/:storeProductId/product-stocks",
      //   name: "StoreProductStocksPage",
      //   component: StoreProductStocksPage,
      // },
      // {
      //   path: "/store-products/:storeId/:productId/:storeProductId/product-stocks/create",
      //   name: "StoreProductStockCreatePage",
      //   component: StoreProductStockCreatePage,
      // },
      {
        path: "/stores/:storeId",
        name: "StoreIdPage",
        component: StoreIdPage,
      },
      // Sale
      {
        path: "/sales",
        name: "SalesPage",
        component: SalesPage,
      },
      {
        path: "/sales/create",
        name: "SaleCreatePage",
        component: SaleCreatePage,
      },
      {
        path: "/sales/:saleId",
        name: "SaleIdPage",
        component: SaleIdPage,
      },
      {
        path: "/sale-reports",
        name: "SaleReports",
        component: SaleReports,
      },
      // Order
      {
        path: "/orders",
        name: "OrdersPage",
        component: OrdersPage,
      },
      {
        path: "/orders/create",
        name: "OrderCreatePage",
        component: OrderCreatePage,
      },
      {
        path: "/orders/:orderId",
        name: "OrderIdPage",
        component: OrderIdPage,
      },
      // OrderDetails
      {
        path: "/orders/:orderId/order-details",
        name: "OrderDetailsPage",
        component: OrderDetailsPage,
      },
      // point-mapping
      {
        path: "/point-mappings",
        name: "PointMappingsPage",
        component: PointMappingsPage,
      },
      {
        path: "/point-mappings/create",
        name: "PointMappingCreatePage",
        component: PointMappingCreatePage,
      },
      {
        path: "/point-mappings/:pointMappingId",
        name: "PointMappingIdPage",
        component: PointMappingIdPage,
      },
      // Inquiry-Request
      {
        path: "/inquiry-requests",
        name: "InquiryRequestsPage",
        component: InquiryRequestsPage,
      },
      {
        path: "/inquiry-requests/create",
        name: "InquiryRequestCreatePage",
        component: InquiryRequestCreatePage,
      },
      {
        path: "/inquiry-requests/:inquiryRequestId",
        name: "InquiryRequestIdPage",
        component: InquiryRequestIdPage,
      },
      // Contact-Request
      {
        path: "/contact-requests",
        name: "ContactRequestsPage",
        component: ContactRequestsPage,
      },
      {
        path: "/contact-requests/create",
        name: "ContactRequestCreatePage",
        component: ContactRequestCreatePage,
      },
      {
        path: "/contact-requests/:contactRequestId",
        name: "ContactRequestIdPage",
        component: ContactRequestIdPage,
      },
      //DeletedAccountRequest Logs,
      {
        path: "/account-delete-request",
        name: "DeleteAccountRequestIndexPage",
        component: DeleteAccountRequestIndexPage,
      },
      // Permissions
      {
        path: "/permissions",
        name: "PermissionsPage",
        component: PermissionsPage,
      },
      {
        path: "/permissions/create",
        name: "PermissionCreatePage",
        component: PermissionCreatePage,
      },
      {
        path: "/permissions/:permissionId",
        name: "PermissionIdPage",
        component: PermissionIdPage,
      },
      // Values
      {
        path: "/values",
        name: "Values",
        component: Values,
      },
      {
        path: "/values/create",
        name: "ValueCreate",
        component: ValueCreate,
      },
      {
        path: "/values/:valueId",
        name: "ValueId",
        component: ValueId,
      },
      // ValueLists
      {
        path: "/value-lists",
        name: "ValueLists",
        component: ValueLists,
      },
      {
        path: "/value-lists/upload",
        name: "ValueListUpload",
        component: ValueListUpload,
      },
      {
        path: "/value-lists/create",
        name: "ValueListCreate",
        component: ValueListCreate,
      },
      {
        path: "/value-lists/:valueListId",
        name: "ValueListId",
        component: ValueListId,
      },
      // Values
      {
        path: "/notifications",
        name: "NotificationsPage",
        component: NotificationsPage,
      },
      {
        path: "/notifications/create",
        name: "NotificationCreatePage",
        component: NotificationCreatePage,
      },
      {
        path: "/notifications/:notificationId",
        name: "NotificationIdPage",
        component: NotificationIdPage,
      },
      // Values
      {
        path: "/festival-banners",
        name: "FestivalBannersPage",
        component: FestivalBannersPage,
      },
      {
        path: "/festival-banners/create",
        name: "FestivalBannerCreatePage",
        component: FestivalBannerCreatePage,
      },
      {
        path: "/festival-banners/:festivalId",
        name: "FestivalBannerIdPage",
        component: FestivalBannerIdPage,
      },
      // Values
      {
        path: "/cancellation-logs",
        name: "CancellationLogsPage",
        component: CancellationLogsPage,
      },
      // UserTimestamps
      {
        path: "/user-timestamps",
        name: "UserTimestamps",
        component: UserTimestamps,
      },

      // Track Progresses
      {
        path: "/track-progresses",
        name: "TrackProgressesPage",
        component: TrackProgressesPage,
      },
      {
        path: "/track-progresses/create",
        name: "TrackProgressCreatePage",
        component: TrackProgressCreatePage,
      },
      {
        path: "/track-progresses/edit",
        name: "TrackProgressIdPage",
        component: TrackProgressIdPage,
      },
      // Booster Driver Rewards
      {
        path: "/booster-driver-rewards",
        name: "BoosterDriverRewardsPage",
        component: BoosterDriverRewardsPage,
      },
      {
        path: "/booster-driver-rewards/create",
        name: "BoosterDriverRewardCreatePage",
        component: BoosterDriverRewardCreatePage,
      },
      {
        path: "/booster-driver-rewards/edit",
        name: "BoosterDriverRewardIdPage",
        component: BoosterDriverRewardIdPage,
      },
      // Booster Driver Logs
      {
        path: "/booster-driver-logs",
        name: "BoosterDriverLogsPage",
        component: BoosterDriverLogsPage,
      },
      // Reward Logs
      {
        path: "/reward-logs",
        name: "RewardLogsPage",
        component: RewardLogsPage,
      },
      // Welcome Bonus
      {
        path: "/welcome-bonuses",
        name: "WelcomeBonusesPage",
        component: WelcomeBonusesPage,
      },
      {
        path: "/welcome-bonuses/create",
        name: "WelcomeBonusCreatePage",
        component: WelcomeBonusCreatePage,
      },
      {
        path: "/welcome-bonuses/edit",
        name: "WelcomeBonusIdPage",
        component: WelcomeBonusIdPage,
      },
      // Track Success Points
      {
        path: "/track-success-points",
        name: "TrackSuccessPointsPage",
        component: TrackSuccessPointsPage,
      },
      {
        path: "/track-success-points/create",
        name: "TrackSuccessPointCreatePage",
        component: TrackSuccessPointCreatePage,
      },
      {
        path: "/track-success-points/edit",
        name: "TrackSuccessPointIdPage",
        component: TrackSuccessPointIdPage,
      },
      // Top 10 Track Success Points
      {
        path: "/top-ten-track-success-points",
        name: "TopTenSuccesPointsPage",
        component: TopTenSuccesPointsPage,
      },
      {
        path: "/top-ten-track-success-points/create",
        name: "TopTenSuccesPointCreatePage",
        component: TopTenSuccesPointCreatePage,
      },
      {
        path: "/top-ten-track-success-points/edit",
        name: "TopTenSuccesPointIdPage",
        component: TopTenSuccesPointIdPage,
      },
      //Enquiry Rewards
      {
        path: "/enquiry-rewards",
        name: "EnquiryRewardsPage",
        component: EnquiryRewardsPage,
      },
      {
        path: "/enquiry-rewards/create",
        name: "EnquiryRewardCreatePage",
        component: EnquiryRewardCreatePage,
      },
      {
        path: "/enquiry-rewards/:positionId/edit",
        name: "EnquiryRewardIdPage",
        component: EnquiryRewardIdPage,
      },
      {
        path: "/enquiry-rewards/:positionId",
        name: "EnquiryRewardsPage2",
        component: EnquiryRewardsPage2,
      },
      // Marketing supervisor Logs
      {
        path: "/marketing-supervisor-logs",
        name: "MarketingSupervisorLogsPage",
        component: MarketingSupervisorLogsPage,
      },
      // Gift Catalog
      {
        path: "/gift-catalogs",
        name: "GiftCatalogsPage",
        component: GiftCatalogsPage,
      },
      {
        path: "/gift-catalogs/create",
        name: "GiftCatalogCreatePage",
        component: GiftCatalogCreatePage,
      },
      {
        path: "/gift-catalogs/:positionId/edit",
        name: "GiftCatalogIdPage",
        component: GiftCatalogIdPage,
      },
      {
        path: "/gift-catalogs/:positionId",
        name: "GiftCatalogIdPage2",
        component: GiftCatalogIdPage2,
      },
      // GiftOrder
      {
        path: "/gift-orders",
        name: "GiftOrdersPage",
        component: GiftOrdersPage,
      },
      {
        path: "/gift-orders/update-status",
        name: "GiftOrdersPage2",
        component: GiftOrdersPage2,
      },
      {
        path: "/gift-orders/create",
        name: "GiftOrderCreatePage",
        component: GiftOrderCreatePage,
      },
      {
        path: "/gift-orders/:giftOrderId", //camel case
        name: "GiftOrderIdPage",
        component: GiftOrderIdPage,
      },
      // Gift Order History
      {
        path: "/gift-order-history",
        name: "GiftOrderHistoryPage",
        component: GiftOrderHistoryPage,
      },
      // Old User Datas
      {
        path: "/old-user-datas",
        name: "OldUserDatasPage",
        component: OldUserDatasPage,
      },
      {
        path: "/old-user-datas/create",
        name: "OldUserDataCreatePage",
        component: OldUserDataCreatePage,
      },
      {
        path: "/old-user-datas/upload",
        name: "OldUserDatasUploadPage",
        component: OldUserDatasUploadPage,
      },
      {
        path: "/old-user-datas/:oldUserDataId",
        name: "OldUserDataIdPage",
        component: OldUserDataIdPage,
      },
      // Old User Datas
      {
        path: "/old-user-used-points",
        name: "OldUserUsedPointsPage",
        component: OldUserUsedPointsPage,
      },
      {
        path: "/old-user-used-points/create",
        name: "OldUserUsedPointCreatePage",
        component: OldUserUsedPointCreatePage,
      },
      {
        path: "/old-user-used-points/upload",
        name: "OldUserUsedPointsUploadPage",
        component: OldUserUsedPointsUploadPage,
      },
      {
        path: "/old-user-used-points/:oldUserUsedPointId",
        name: "OldUserUsedPointIdPage",
        component: OldUserUsedPointIdPage,
      },
      // Chat
      {
        path: "/chats",
        name: "ChatPage",
        component: ChatPage,
      },
      // Messenger (Real-time chat)
      {
        path: "/messenger",
        name: "MessengerPage",
        component: MessengerPage,
      },
      // Rawmaterials
      {
        path: "/raise-complaints",
        name: "RaiseComplaintsPage",
        component: RaiseComplaintsPage,
      },
      {
        path: "/raise-complaints/create",
        name: "RaiseComplaintCreatePage",
        component: RaiseComplaintCreatePage,
      },
      {
        path: "/raise-complaints/:raiseComplaintId",
        name: "RaiseComplaintIdPage",
        component: RaiseComplaintIdPage,
      },
      // PayCreditBalance
      {
        path: "/pay-credit-balance",
        name: "PayCreditBalancePage",
        component: PayCreditBalancePage,
      },
      {
        path: "/pay-credit-balance/create",
        name: "PayCreditBalanceCreatePage",
        component: PayCreditBalanceCreatePage,
      },
      {
        path: "/pay-credit-balance/:receiptId",
        name: "PayCreditBalanceIdPage",
        component: PayCreditBalanceIdPage,
      },
      // Shipments
      {
        path: "/shipments/create",
        name: "CreateShipmentPage",
        component: CreateShipmentPage,
        meta: { requiresAuth: true }
      },
      // API Monitoring
      {
        path: "/api-logs",
        name: "ApiLogsPage",
        component: ApiLogsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/api-logs/:id",
        name: "ApiLogIdPage",
        component: ApiLogIdPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/error-logs",
        name: "ErrorLogsPage",
        component: ErrorLogsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/error-logs/:id",
        name: "ErrorLogIdPage",
        component: ErrorLogIdPage,
        meta: { requiresAuth: true }
      },
    ],
  },
  // End AuthLayout

  // UnAuthLayout
  {
    path: "/unauth",
    name: "UnAuthLayout",
    component: UnAuthLayout,
    children: [
      {
        path: "/login",
        name: "LoginPage",
        component: LoginPage,
      },
      {
        path: "/forgot-password",
        name: "ForgotPasswordPage",
        component: ForgotPasswordPage,
      },
      {
        path: "/account-delete-request/create",
        name: "DeleteAccountRequestPage",
        component: DeleteAccountRequestPage,
      },
    ],
  },
  //End UnAuthLayout
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (store.getters["auth/authenticated"] && from.name) {
    to.params.startTime = new Date();
  }
  if (
    to.name === "LoginPage" ||
    to.name === "RegisterPage" ||
    to.name === "DeleteAccountRequestPage" ||
    to.name === "ForgotPasswordPage"
  ) {
    console.log("1");
    if (store.getters["auth/authenticated"]) {
      console.log("2");
      let company_id = store.getters["auth/company"].id;
      if (company_id) {
        console.log("3");
        console.log(company_id);
      }
      return next({
        name: "HomePage",
      });
    }
    next();
  } else if (!store.getters["auth/authenticated"]) {
    console.log("4");
    return next({
      name: "LoginPage",
    });
  } else if (to.name === null) {
    console.log("5");
    return next({
      name: "HomePage",
    });
  }
  next();
});

router.afterEach(async (to, from) => {
  if (
    store.getters["auth/authenticated"] &&
    from.name &&
    !to.name.includes("Create") &&
    !to.name.includes("Edit")
  ) {
    let endTime = new Date();
    let startTime = from.params.startTime;
    let timeSpentInSeconds = "0";
    if (startTime) {
      timeSpentInSeconds = (endTime - startTime) / 1000;
    }
    if (timeSpentInSeconds > 1200) {
      timeSpentInSeconds = 1200;
    }
    console.log(
      `Time spent on "${to.name}" route: ${timeSpentInSeconds} seconds`
    );
    let form = {
      from_path: from.path,
      from_name: from.name,
      user_id: store.getters["auth/user"].id,
      timespent: timeSpentInSeconds,
    };
    await axios.post(`/user_timestamps`, form);
  }
});

export default router;
